import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import Intl from 'intl';// eslint-disable-line no-unused-vars
import reactMixin from 'react-mixin';
import {IntlMixin} from 'react-intl';
import {Router} from 'react-router';

@reactMixin.decorate(IntlMixin) class IntlRouter extends Router {
  //getChildContext() {
  //  const context = this.context,
  //  props = this.props;
  //
  //  return {
  //    locales: props.locales || context.locales,
  //    formats: props.formats || context.formats,
  //    messages: props.messages || context.messages,
  //
  //    config: props.config || context.config,
  //
  //    router: this
  //  };
  //}
  //
  //static childContextTypes = {
  //  locales: React.PropTypes.oneOfType([
  //    React.PropTypes.string,
  //    React.PropTypes.array
  //  ]),
  //
  //  formats: React.PropTypes.object,
  //  messages: React.PropTypes.object,
  //
  //  config: React.PropTypes.object.isRequired,
  //
  //  router: React.PropTypes.object.isRequired
  //}

  //render() {
    //let context = (<RouterContext />);

    //return <ReduxRouter router={ReduxRouter} />
  //}
}
export default IntlRouter;



// WEBPACK FOOTER //
// /src/routes/IntlRouter.js